import * as dataHelper from './dataHelper';
import * as userDataHelper from './userDataHelper';
import * as kpiHelper from './kpiHelper';
import * as indicatorHelper from './indicatorHelper';
import * as environmentHelper from './environmentHelper';
import * as localStorage from '../localStorage/localStorage';
import * as appConstants from '../constants/appConstants';
import * as assetConstants from '../constants/assetConstants';
import * as objectConstants from '../constants/objectConstants';
import * as appModels from '../models/appModels';
import * as componentModels from '../models/componentModels';
import {SHORT_HAND_KEYS} from '../models/shortHandModels';
import * as colourConstants from '../constants/colourConstants';
import * as colourHelper from './colourHelper';
import * as colourModels from '../models/colourModels';
import _ from 'lodash';
import striptags from 'striptags';

export function updateInitDataState(initData, constant) {
    let nextIndex = -1;
    for (let i = 0; i < initData.initialisedStates.length; i++) {
        let stateObj = initData.initialisedStates[i];
        if (stateObj.constant === constant) {
            stateObj = Object.assign({}, stateObj, {
                complete: true
            });
            if (i < (initData.initialisedStates.length - 1)) {
                nextIndex = i + 1;
            }
            initData.initialisedStates = dataHelper.immutableSplice(initData.initialisedStates, i, 1, stateObj);

        }
    }
    initData = Object.assign({}, initData,
        {
            initialised: nextIndex <= -1,
            currentState: nextIndex > -1 ? initData.initialisedStates[nextIndex].constant : initData.currentState,
            currentStateIndex: nextIndex > -1 ? nextIndex : initData.currentStateIndex
        }
    );
    return initData;
}

export function setInitialisationComplete(initData) {
    initData = Object.assign({}, initData,
        {
            checkInitialised: false
        }
    );
    return initData;
}

export function getInitStateByConstant(initStates, constant) {
    const initState = initStates.filter(initState => initState.constant == constant);
    if (initState) return initState[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function setStudentName(student_name) {
    let studenNameArray = student_name.split(', ').reverse();
    return {
        student_name: student_name,
        first_name: studenNameArray.length > 1 ? studenNameArray[0] : student_name,
        last_name: studenNameArray.length > 1 ? studenNameArray[1] : "",
    };
}

//Content Data
export function setContentData() {
    let default_language = getArrayObjectByKey(localStorage.contentData.experience.languages, "is_selected", true).language_code;// localStorage.contentData.experience.default_langauge;
    let user_role = localStorage.contentData.experience.publish_details.role;
    let user_name = localStorage.contentData.experience.publish_details.published_by;

    localStorage.set("default_langauge", default_language);
    localStorage.set("user_role", user_role.toLowerCase());
    localStorage.set("user_name", user_name);
    localStorage.setObject("experience_locale", localStorage.contentData.experience.locale[default_language]);
    localStorage.set("tracking_type", localStorage.contentData.experience.tracking_type);
    localStorage.setArray("bites", localStorage.contentData.experience.bites);
    localStorage.set("assets", localStorage.contentData.experience.assets);
    localStorage.set("strings", localStorage.contentData.experience.strings[default_language]);
    localStorage.setArray("resources", localStorage.contentData.experience.resources);
    localStorage.setObject("localeOptions", localStorage.contentData.experience.locale);
    localStorage.setArray("languages", localStorage.contentData.experience.languages);

    let primary_colours = colourHelper.getDarkAndLightColourSwatchRange(localStorage.contentData.experience.theme_colors.primary_color, colourConstants.THEME_PRIMARY_COLOR);
    let secondary_colours = colourHelper.getDarkAndLightColourSwatchRange(localStorage.contentData.experience.theme_colors.secondary_color, colourConstants.THEME_SECONDARY_COLOR);

    let shades = colourHelper.getDarkToLightColourSwatchRange(colourConstants.DARK_GREY_COLOR, colourConstants.THEME_MONOCHROME_COLOR);

    let colour_swatches = [
        {
            constant: colourConstants.THEME_PRIMARY_COLOR,
            label: colourConstants.THEME_PRIMARY_COLORS_LABEL,
            colours: primary_colours,
        },
        {
            constant: colourConstants.THEME_SECONDARY_COLOR,
            label: colourConstants.THEME_SECONDARY_COLORS_LABEL,
            colours: secondary_colours,
        },
        {
            constant: colourConstants.THEME_MONOCHROME_COLOR,
            label: colourConstants.THEME_MONOCHROME_COLORS_LABEL,
            colours: shades,
        }
    ];

    colourModels.set('button_color', localStorage.contentData.experience.theme_colors.button_color);
    colourModels.setArray('colour_swatches', colour_swatches);

    let primary_color_value = localStorage.contentData.experience.theme_colors.primary_color;
    let secondary_color_value = localStorage.contentData.experience.theme_colors.secondary_color;
    let button_color_value = localStorage.contentData.experience.theme_colors.button_color;
    let background_layer_color_value = localStorage.contentData.experience.theme_colors.background_layer_color;
    let titles_and_sections_color_value = localStorage.contentData.experience.theme_colors.titles_and_sections_color;

    if (isDefined(primary_color_value)) {
        colourModels.set('primary_color',colourHelper.getColourValueString(primary_color_value));
    }

    if (isDefined(secondary_color_value)) {
        colourModels.set('secondary_color',colourHelper.getColourValueString(secondary_color_value));
    }

    if (isDefined(button_color_value)) {
        colourModels.set('button_color',colourHelper.getColourValueString(button_color_value));
    }

    if (isDefined(background_layer_color_value)) {
        colourModels.set('background_layer_color',colourHelper.getColourValueString(background_layer_color_value));
    }

    if (isDefined(titles_and_sections_color_value)) {
        colourModels.set('titles_and_sections_color',colourHelper.getColourValueString(titles_and_sections_color_value));
    }

    document.title = localStorage.experience_locale.experience_title;
    document.documentElement.setAttribute('lang', default_language);
}

export function canSeeContent(screen) {
    if (screen.screen_status_code === appConstants.SCREEN_STATUS_OUTLINE || screen.screen_status_code === appConstants.SCREEN_STATUS_OUTLINE_REVIEW || screen.screen_status_code === appConstants.SCREEN_STATUS_IN_PROGRESS) {
        if (localStorage.user_role === appConstants.USER_ROLE_LEAD) {
            return true;
        }
    } else {
        return true;
    }
}

export function previewDisplayType() {

}

export function getExperienceTitle() {
    return localStorage.experience_locale.experience_title;

}

export function getLocaleString(code) {
    return isDefined(localStorage.strings[code]) ? localStorage.strings[code] : "";
}

//PASS ARRAY OF LOCALS FROM DATA AND RETREIVES OBJECT OF STRINGS FOR CURRENT LOCALE
export function getLocalData(obj) {
    if (isDefined(obj.locale)) {
        return isDefined(obj.locale[localStorage.default_langauge]) ? obj.locale[localStorage.default_langauge] : obj.locale[getPrimaryLocale(obj.locale)];

    } else {
        return {};
    }
}


//GET BITE DATA
export function getBiteByScreenId(screen_id) {
    let returnBiteId = {};
    let biteFound = false;
    if (!isNaN(screen_id)) {
        for (let i = 0; i < localStorage.bites.length; i++) {
            let bite = localStorage.bites[i];
            for (let s = 0; s < bite.screens.length; s++) {
                let screen = bite.screens[s];
                if (parseInt(screen.screen_id) === parseInt(screen_id)) {
                    biteFound = true;
                    return bite.bite_id;
                }

                if (isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
                    for (let b = 0; b < screen.sub_screens.length; b++) {
                        let sub_screen = screen.sub_screens[b];
                        if (parseInt(sub_screen.screen_id) === parseInt(screen_id)) {
                            biteFound = true;
                            return bite.bite_id;
                        }
                    }
                }
            }
        }
    } else {
        return localStorage.bites[0].bite_id;
    }
}

export function getBiteById(bite_id) {
    const bite = localStorage.bites.filter(bite => bite.bite_id == bite_id);
    if (bite) return bite[0]; //since filter returns an array, have to grab the first.
    return null;

}

//GET TOOLBOX DATA
export function getToolbox() {
    // const toolbox = localStorage.toolbox;
    //return toolbox;
}

export function getDefaultToolboxPage() {
    // const toolbox = localStorage.toolbox;
    //if (toolbox.screens.length) return toolbox.screens[0].toolbox_id;
    //return null;
}


//GET SCREEN DATA
export function getNextScreenId(screen_id) {
    if (!isNaN(screen_id)) {
        return getNextScreenById(screen_id);
    } else {
        return getFirstScreenId();
    }

}

export function getNextScreen(screen_id) {
    if (!isNaN(screen_id)) {
        return getScreenById(screen_id);
    } else {
        return getFirstScreen();
    }
}

function getFirstScreen() {
    return Object.assign({}, localStorage.contentData.experience.bites[0].screens[0]);
}

export function getScreenById(screen_id) {
    let returnScreen = {};
    let screenFound = false;
    let bites = localStorage.contentData.experience.bites;
    for (let i = 0; i < bites.length; i++) {
        let bite = bites[i];
        for (let s = 0; s < bite.screens.length; s++) {
            let screen = bite.screens[s];
            if (screen.screen_id == screen_id) {
                screenFound = true;
                returnScreen = Object.assign({}, screen);
                break;
            }
        }
        if (screenFound) {
            break;
        }
    }
    return returnScreen;
}


function getFirstScreenId() {
    return localStorage.contentData.experience.bites[0].screens[0].screen_id;
}

function getNextScreenById(screen_id) {
    let bite_id = getBiteByScreenId(screen_id);
    let bite = getBite(getBiteByScreenId(screen_id));
    let returnScreenId = "";

    for (let s = 0; s < bite.screens.length; s++) {
        let screen = bite.screens[s];
        if (parseInt(screen.screen_id) === parseInt(screen_id)) {
            if (s < (bite.screens.length - 1)) {
                returnScreenId = bite.screens[s + 1].screen_id;
            }
            break;
        }
    }
    return returnScreenId;
}

export function getBiteScreen(bite_id, screen_id) {
    let bite = getBite(bite_id);
    return getScreen(bite, parseInt(screen_id));
}

export function getBite(bite_id) {
    const bite = localStorage.bites.filter(bite => bite.bite_id === bite_id);
    if (bite) return bite[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getScreen(bite, screen_id) {
    const screen = bite.screens.filter(screen => screen.screen_id === screen_id);
    if (screen) return screen[0]; //since filter returns an array, have to grab the first.
    return null;
}


export function getBackgroundAsset(background) {

    const asset = localStorage.assets.filter(asset => asset.type === assetConstants.ASSET_TYPE_BACKGROUND && asset.id === background.background_id);
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getLargeBackgroundAsset(upload) {
    const asset = localStorage.assets.filter(asset => asset.type === assetConstants.ASSET_TYPE_LARGE_BACKGROUND && asset.id === upload.id);
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getMobileBackgroundAsset(upload) {

    const asset = localStorage.assets.filter(asset => asset.type === assetConstants.ASSET_TYPE_MOBILE_BACKGROUND && asset.id === upload.id);
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getHeaderLogoAsset(header_logo) {

    const asset = localStorage.assets.filter(asset => asset.type === assetConstants.ASSET_TYPE_HEADER_LOGO && asset.id === header_logo.id);
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getFooterLogoAsset(footer_logo) {

    const asset = localStorage.assets.filter(asset => asset.type === assetConstants.ASSET_TYPE_FOOTER_LOGO && asset.id === footer_logo.id);
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getIconAsset(icon) {

    const asset = localStorage.assets.filter(asset => asset.type === assetConstants.ASSET_TYPE_ICON && (asset.id === icon.id || asset.id === icon.asset_id));
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getVideoAsset(video) {
    const asset = localStorage.assets.filter(asset => asset.type === assetConstants.ASSET_TYPE_VIDEO && (asset.id === video.id || asset.id === video.asset_id));
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getImageAsset(image) {

    const asset = localStorage.assets.filter(asset => asset.type === assetConstants.ASSET_TYPE_IMAGE && (asset.id === image.id || asset.id === image.asset_id));
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getLibraryImageAsset(image) {

    const asset = localStorage.assets.filter(asset => asset.type === assetConstants.ASSET_TYPE_LIBRARY_IMAGE && (asset.id === image.id || asset.id === image.asset_id));
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getDocumentAsset(document) {

    const asset = localStorage.assets.filter(asset => asset.type === assetConstants.ASSET_TYPE_DOCUMENT && (asset.id === document.id || asset.id === document.asset_id));
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getLinkAsset(link) {

    const asset = localStorage.assets.filter(asset => asset.type === assetConstants.ASSET_TYPE_LINK && (asset.id === link.id || asset.id === link.asset_id));
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getHotspotBackgroundAsset(hotspotBackground) {
    const asset = localStorage.assets.filter(asset => asset.type === assetConstants.ASSET_TYPE_HOTSPOT_BACKGROUND && asset.id === hotspotBackground.id);
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getAudioAsset(audio) {
    const asset = localStorage.assets.filter(asset => (asset.type === assetConstants.ASSET_AUDIO || asset.type === assetConstants.ASSET_CHILD_AUDIO) && (asset.id === audio.id || asset.id === audio.asset_id));
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getAudioOptionAsset(audio) {
    const asset = localStorage.assets.filter(asset => asset.type === assetConstants.ASSET_CHILD_AUDIO_OPTION && (asset.id === audio.id || asset.id === audio.asset_id));
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}


export function getEarnedAsset(upload) {

    const asset = localStorage.assets.filter(asset => asset.type === assetConstants.ASSET_TYPE_EARNED && asset.id === upload.id);
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getUnearnedAsset(upload) {

    const asset = localStorage.assets.filter(asset => asset.type === assetConstants.ASSET_TYPE_UNEARNED && asset.id === upload.id);
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}


export function getCharacterAsset(screenAsset) {
    let character = {};
    _.forEach(localStorage.assets, function (asset) {
        if (asset.type === assetConstants.ASSET_TYPE_ID_CHARACTER && asset.id === screenAsset.id) {
            _.forEach(asset.positions, function (pos) {
                if (pos.position === screenAsset.position) {
                    character = Object.assign({}, pos);
                }
            });
        }
    });
    return character;
}

export function getCharacterPose(character, screenAsset) {
    let characterPose = {};
    _.forEach(character.poses, function (pose) {
        if (pose.pose === screenAsset.pose) {
            characterPose = Object.assign({}, pose, {
                position: screenAsset.position
            });
        }
    });

    return characterPose;
}

export function getLogoAsset(assets) {
    const asset = assets.filter(asset => asset.type == assetConstants.ASSET_TYPE_IMAGE && asset.type_id == assetConstants.ASSET_TYPE_ID_LOGO);
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getMenuThumbnailAsset(assets) {
    const asset = assets.filter(asset => asset.type == assetConstants.ASSET_TYPE_IMAGE && asset.type_id == assetConstants.ASSET_TYPE_ID_MENU_THUMBNAIL);
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}

/*
export function getImageAsset(assets) {
    const asset = assets.filter(asset => asset.type == assetConstants.ASSET_TYPE_IMAGE && asset.type_id == assetConstants.ASSET_TYPE_ID_IMAGE);
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}*/

export function getObjectOption(options, option_id) {
    for (let i = 0; i < options.length; i++) {
        let option = options[i];

        if (parseInt(option.option_id) === parseInt(option_id)) {
            return option;
        }
    }
    return null;
}

export function getObjectOptionIndex(options, option_id) {
    for (let i = 0; i < options.length; i++) {
        let option = options[i];
        if (parseInt(option.option_id) === parseInt(option_id)) {
            return i;
        }
    }
    return -1;
}

export function getLastItemOfArray(array) {
    return array[array.length - 1];
}

export function getArrayObjectByKey(array, key, target) {
    const obj = array.filter(obj => obj[key] === target);
    if (obj) return obj[0]; //since filter returns an array, have to grab the first.
    return null;

}


export function getArrayObjectIndexByKey(array, key, target) {
    for (let i = 0; i < array.length; i++) {
        let item = array[i];

        if (item[key] === target) {
            return i;
        }
    }
    return -1;
}

export function getArrayObjectIndexByKeys(array, key1,target1,key2,target2) {
    for (let i = 0; i < array.length; i++) {
        let item = array[i];

        if (item[key1] === target1 && item[key2] === target2 ) {
            return i;
        }
    }
    return -1;
}



export function getTypeCount(array, key, target) {
    let objectArray = [];
    for (let i = 0; i < array.length; i++) {
        let item = array[i];
        if (item[key] === target) {
            objectArray = dataHelper.immutablePush(objectArray, item);
        }
    }

    return objectArray;
}

export function getNotOfTypeCount(array, key, target) {
    let objectArray = [];
    for (let i = 0; i < array.length; i++) {
        let item = array[i];
        if (item[key] !== target) {
            objectArray = dataHelper.immutablePush(objectArray, item);
        }
    }

    return objectArray;
}

export function getShortHandKeyByRef(ref) {
    const obj = SHORT_HAND_KEYS.filter(obj => obj.ref === ref);
    if (obj) return obj[0]; //since filter returns an array, have to grab the first.
    return null;

}

export function getRefByShortHandKey(key) {
    const obj = SHORT_HAND_KEYS.filter(obj => obj.key === key);
    if (obj) return obj[0]; //since filter returns an array, have to grab the first.
    return null;

}

export function isDefined(val) {
    return typeof val !== "undefined";
}

export function isObjectEleDefined(val) {
    return typeof val !== "undefined" && val !== null;
}



export function isEleDefined(val) {
    return typeof val !== "undefined" && val !== null;
}


export function getOptionParentDetails(option_id) {
    let returnObject = {};
    //let screenFound = false;
    let bites = localStorage.contentData.experience.bites;

    _.forEach(bites, function (bite) {
        _.forEach(bite.screens, function (screen) {
            if (isDefined(screen.objects) && screen.objects.length > 0 && (!isDefined(screen.sub_screens) || (isDefined(screen.sub_screens) && screen.sub_screens.length === 0 ) )) {
                _.forEach(screen.objects, function (object) {
                    if (isDefined(object.options)) {
                        _.forEach(object.options, function (option) {
                            if (isDefined(object.options)) {
                                if (option.option_id === option_id) {
                                    returnObject = Object.assign({}, returnObject, {
                                        bite: bite,
                                        screen: screen,
                                        object: object,
                                        option: option
                                    });
                                }
                            }
                        });
                    }
                });
            } else if (isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
                _.forEach(screen.sub_screens, function (sub_screen) {
                    if (isDefined(sub_screen.objects)) {
                        _.forEach(sub_screen.objects, function (object) {
                            if (isDefined(object.options)) {
                                _.forEach(object.options, function (option) {
                                    if (isDefined(object.options)) {
                                        if (option.option_id === option_id) {
                                            returnObject = Object.assign({}, returnObject, {
                                                bite: bite,
                                                screen: screen,
                                                sub_screen: sub_screen,
                                                object: object,
                                                option: option
                                            });
                                        }
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });
    });
    return returnObject;
}


export function getOptionByLabelName(option_label, options) {
    let returnOption = {};
    _.forEach(options, function (option) {
        if (isDefined(option.locale)) {
            for (let i in option.locale) {
                if (option_label === striptags(option.locale[i].option)) {
                    returnOption = Object.assign({}, {}, {
                        option: option
                    });
                }
            }
        }
    });
    return returnOption;
}


export function geScreenParentDetails(screen_id) {
    let returnObject = undefined;

    let bites = localStorage.contentData.experience.bites;

    for (let i = 0; i < bites.length; i++) {
        let bite = bites[i];
        for (let s = 0; s < bite.screens.length; s++) {
            let screen = bite.screens[s];
            if (isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
                for (let c = 0; c < screen.sub_screens.length; c++) {
                    let sub_screen = screen.sub_screens[c];
                    if (sub_screen.screen_id === screen_id) {
                        returnObject = Object.assign({}, screen);
                        break;
                    }
                }
            }
        }
    }
    return returnObject;
}


export function getAssetParentDetails(asset_id) {
    let returnObject = {};
    //let screenFound = false;
    let bites = localStorage.contentData.experience.bites;

    _.forEach(bites, function (bite) {
        _.forEach(bite.screens, function (screen) {
            if (isDefined(screen.objects) && screen.objects.length > 0 && (!isDefined(screen.sub_screens) || (isDefined(screen.sub_screens) && screen.sub_screens.length === 0 ) )) {
                _.forEach(screen.objects, function (object) {
                    if (object.asset_id === asset_id) {
                        returnObject = Object.assign({}, returnObject, {
                            bite: bite,
                            screen: screen,
                            object: object,
                        });
                    }
                });
            } else if (isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
                _.forEach(screen.sub_screens, function (sub_screen) {
                    if (isDefined(sub_screen.objects)) {
                        _.forEach(sub_screen.objects, function (object) {
                            if (object.asset_id === asset_id) {
                                returnObject = Object.assign({}, returnObject, {
                                    bite: bite,
                                    screen: screen,
                                    sub_screen: sub_screen,
                                    object: object
                                });
                            }
                        });
                    }
                });
            }
        });
    });
    return returnObject;
}

export function getObjectCheckedOptionsByKpiHistoryOptions(optionIdList) {
    let checkedOptions = [];
    for (let i = 0; i < optionIdList.length; i++) {
        let option_id = optionIdList[i];
        let optionDetails = getOptionParentDetails(option_id);
        checkedOptions = dataHelper.immutablePush(checkedOptions, optionDetails.option);
    }
    return checkedOptions;
}

export function getObjectOutcomeByKpiHistoryOptions(optionIdList) {
    let checkedOptions = [];
    let screenObject = {};
    for (let i = 0; i < optionIdList.length; i++) {
        let option_id = optionIdList[i];
        let optionDetails = getOptionParentDetails(option_id);
        if (i === 0) {
            screenObject = Object.assign({}, optionDetails.object);
        }
        checkedOptions = dataHelper.immutablePush(checkedOptions, optionDetails.option);
    }
    let totalCorrectAnswerCount = getTypeCount(screenObject.options, "result", "best").length;
    let correctAnswers = getTypeCount(checkedOptions, "result", "best");
    let incorrectAnswers = getNotOfTypeCount(checkedOptions, "result", "best");
    let kpis = kpiHelper.averageKpis(checkedOptions);
    let outcome = {};
    if (correctAnswers.length === totalCorrectAnswerCount && incorrectAnswers.length === 0) {
        outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "best"));
    } else {
        if (correctAnswers.length > 0) {
            outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "ok"));
            if (!isDefined(outcome.result)) {
                outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "poor"));
            }
        } else {
            outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "poor"));
        }

    }

    return outcome;
}

export function getOrderingObjectOutcomeByKpiHistoryOptions(options) {
    let checkedOptions = [];
    let screenObject = {};
    for (let i = 0; i < options.length; i++) {
        let option_id = options[i].option_id;
        let optionDetails = getOptionParentDetails(option_id);
        if (i === 0) {
            screenObject = Object.assign({}, optionDetails.object);
        }
        //checkedOptions = dataHelper.immutablePush(checkedOptions, optionDetails.option);
    }
    let totalCorrectAnswerCount = screenObject.options.length;
    let correctAnswers = getTypeCount(options, "is_correct", true);
    let incorrectAnswers = getNotOfTypeCount(options, "is_correct", true);
    let kpis = kpiHelper.averageKpis(options);
    let indicators = indicatorHelper.getCheckedOptionIndicators(options);
    let outcome = {};
    if (correctAnswers.length === totalCorrectAnswerCount && incorrectAnswers.length === 0) {
        outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "best"), {
            indicators: indicators
        });
    } else {
        if (correctAnswers.length > 0) {
            outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "ok"), {
                indicators: indicators
            });
            if (!isDefined(outcome.result)) {
                outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "poor"), {
                    indicators: indicators
                });
            }
        } else {
            outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "poor"), {
                indicators: indicators
            });
        }

    }

    return outcome;
}

export function _getObjectOutcomeByKpiHistoryOptions(optionIdList) {
    let checkedOptions = [];
    let screenObject = {};
    for (let i = 0; i < optionIdList.length; i++) {
        let option_id = optionIdList[i];
        let optionDetails = getOptionParentDetails(option_id);
        if (i === 0) {
            screenObject = Object.assign({}, optionDetails.object);
        }
        checkedOptions = dataHelper.immutablePush(checkedOptions, optionDetails.option);
    }
    let totalCorrectAnswerCount = getTypeCount(screenObject.options, "result", "best").length;
    let correctAnswers = getTypeCount(optionIdList, "result", "best");
    let incorrectAnswers = getNotOfTypeCount(optionIdList, "result", "best");
    let kpis = kpiHelper.averageKpis(optionIdList);
    let outcome = {};
    if (correctAnswers.length === totalCorrectAnswerCount && incorrectAnswers.length === 0) {
        outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "best"), {
            kpis: kpis
        });
    } else {
        //if (this.state.screenObject.allowPartlyCorrectResponses) {

        if (correctAnswers.length > 0) {
            outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "ok"), {
                kpis: kpis
            });
            if (!isDefined(outcome.result)) {
                outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "poor"), {
                    kpis: kpis
                });
            }
        } else {
            outcome = Object.assign({}, getArrayObjectByKey(screenObject.outcomes, "result", "poor"), {
                kpis: kpis
            });
        }

    }

    return outcome;
}

export function getObjectOptionIds(object) {
    let optionIds = [];
    for (let i = 0; i < object.options.length; i++) {
        let option = object.options[i];
        optionIds = dataHelper.immutablePush(optionIds, option.option_id);
    }
    return optionIds;
}


export function getRenderableObjects(userData, bite_id, objects) {
    let renderableObjects = [];

    for (let i = 0; i < objects.length; i++) {
        let object = objects[i];

        if (isDefined(object.options)) {
            let optionIds = getObjectOptionIds(object);
            let kpiUserData = userDataHelper.getUserResponseByOptionIds(userData, bite_id, optionIds);
            if (isDefined(kpiUserData)) {
                if (kpiUserData.option_id.length === 1) {
                    let optionDetails = getOptionParentDetails(kpiUserData.option_id[0]);

                    if (optionDetails.option.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE || optionDetails.option.progression === objectConstants.OBJECT_PROGRESSION_GO_TO) {
                        renderableObjects = dataHelper.immutablePush(renderableObjects, object);
                    } else if (optionDetails.option.progression === objectConstants.OBJECT_PROGRESSION_TERMINAL) {
                        renderableObjects = dataHelper.immutablePush(renderableObjects, object);
                        break;
                    }
                } else if (kpiUserData.option_id.length > 1) {
                    let outcome = getObjectOutcomeByKpiHistoryOptions(kpiUserData.option_id);

                    if (outcome.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE || outcome.progression === objectConstants.OBJECT_PROGRESSION_GO_TO) {
                        renderableObjects = dataHelper.immutablePush(renderableObjects, object);
                    } else if (outcome.progression === objectConstants.OBJECT_PROGRESSION_TERMINAL) {
                        renderableObjects = dataHelper.immutablePush(renderableObjects, object);
                        break;
                    }
                }
            } else {
                let status = userDataHelper.getObjectStatus(userData, object.object_id).status;
                if (status === objectConstants.STATUS_COMPLETE && object.object_type === "compare_answer") {
                    renderableObjects = dataHelper.immutablePush(renderableObjects, object);
                }
            }
        } else {
            renderableObjects = dataHelper.immutablePush(renderableObjects, object);
        }
    }
    return renderableObjects;
}


export function closeWindow() {
    /*window.close();*/
    /*window.parent.close();
    top.close();*/
    top.window.close();
    /*parent.close();*/
}

export function goBack() {
    window.history.back();
    window.history.go(-1);
    history.go(-1);
    return false;
}

//todo: move later
export function getUserResponseKpis(userBite, screen_id, asset_id, option_id) {
    let userKpis = [];
    for (let i = 0; i < userBite.kpis.length; i++) {
        let kpi = userBite.kpis[i];
        let kpiHistory = kpi.history;
        for (let h = 0; h < kpiHistory.length; h++) {
            let kpiResponse = kpiHistory[h];
            if (kpiResponse.screen_id == screen_id && kpiResponse.asset_id === asset_id && kpiResponse.option_id === option_id) {
                if (userKpis.indexOf(kpiResponse.code) === -1) {
                    userKpis = dataHelper.immutablePush(userKpis, kpiResponse);
                } else {
                    let index = userKpis.indexOf(kpiResponse.code);
                    if (kpiResponse.attempt > userKpis[index].attempt) {
                        userKpis = dataHelper.immutableSplice(userKpis, index, 1, kpiResponse);
                    }
                }
            }
        }
    }
    return userKpis;
}


export function _getImagesToPreload(assets) {
    let imagesToPreload = [];
    for (let i = 0; i < assets.length; i++) {
        let asset = assets[i];
        if (asset.type === assetConstants.ASSET_TYPE_ID_CHARACTER) {
            if (isDefined(asset.positions)) {
                for (let p = 0; p < asset.positions.length; p++) {
                    let position = asset.positions[p];
                    if (isDefined(position.poses)) {
                        for (let o = 0; o < position.poses.length; o++) {
                            let pose = position.poses[o];
                            if (imagesToPreload.indexOf(pose.src) === -1) {
                                imagesToPreload = dataHelper.immutablePush(imagesToPreload, pose.src);
                            }
                        }
                    }
                }
            }
        } else {
            let fileExtention = dataHelper.getFileExtention(asset.src);
            if (appModels.ALLOWED_IMAGE_FILES.indexOf(fileExtention) > -1) {
                if (imagesToPreload.indexOf(asset.src) === -1) {
                    imagesToPreload = dataHelper.immutablePush(imagesToPreload, asset.src);
                }
            }

        }
    }
    return imagesToPreload;
}

export function getPrimaryLocale(locale) {
    return Object.keys(locale)[0];
}

export function getImagesToPreload(default_langauge, assets) {

    let imagesToPreload = [];
    let srcArray = [];
    for (let i = 0; i < assets.length; i++) {
        let asset = assets[i];
        if (asset.type === assetConstants.ASSET_TYPE_ID_CHARACTER) {
            if (isDefined(asset.positions)) {
                for (let p = 0; p < asset.positions.length; p++) {
                    let position = asset.positions[p];
                    if (isDefined(position.poses)) {
                        for (let o = 0; o < position.poses.length; o++) {
                            let pose = position.poses[o];
                            let poseArray = [];
                            if (isDefined(asset.locale)) {

                                let assetLocale = isDefined(pose.locale[default_langauge]) ? pose.locale[default_langauge] : pose.locale[getPrimaryLocale(pose.locale)];
                                poseArray = assetLocale.src.split("?");
                            } else {
                                poseArray = pose.src.split("?");
                            }

                            let poseSrc = poseArray[0];
                            //console.log(poseSrc);

                            let originalSrc = pose.src;
                            if (isDefined(pose.locale)) {
                                originalSrc = isDefined(pose.locale[default_langauge]) ? pose.locale[default_langauge].src : pose.locale[getPrimaryLocale(pose.locale)].src;
                            }
                            if (imagesToPreload.indexOf(originalSrc) === -1 && srcArray.indexOf(poseSrc) === -1) {
                                imagesToPreload = dataHelper.immutablePush(imagesToPreload, originalSrc);
                                srcArray = dataHelper.immutablePush(srcArray, poseSrc);
                            }
                        }
                    }
                }
            }
        } else {

            let assetArray = [];
            if (isDefined(asset.locale)) {
                let assetLocale = isDefined(asset.locale[default_langauge]) ? asset.locale[default_langauge] : asset.locale[getPrimaryLocale(asset.locale)];
                assetArray = assetLocale.src.split("?");
            } else {
                assetArray = asset.src.split("?");
            }
            let assetSrc = assetArray[0];
            // console.log(assetSrc);
            let fileExtention = dataHelper.getFileExtention(assetSrc);
            if (appModels.ALLOWED_IMAGE_FILES.indexOf(fileExtention) > -1) {
                let originalSrc = asset.src;
                if (isDefined(asset.locale)) {
                    originalSrc = isDefined(asset.locale[default_langauge]) ? asset.locale[default_langauge].src : asset.locale[getPrimaryLocale(asset.locale)].src;
                }
                if (imagesToPreload.indexOf(originalSrc) === -1 && srcArray.indexOf(assetSrc) === -1) {
                    imagesToPreload = dataHelper.immutablePush(imagesToPreload, originalSrc);
                    srcArray = dataHelper.immutablePush(srcArray, assetSrc);
                }
            }

        }
    }
    return imagesToPreload;
}


export function getAudioToPreload(assets) {
    let audioToPreload = [];
    for (let i = 0; i < assets.length; i++) {
        let asset = assets[i];
        let assetSrc = isDefined(asset.locale) ? getLocalData(asset).src : asset.src;
        //console.log(assetSrc);
        if (isDefined(assetSrc)) {
            let fileExtention = dataHelper.getFileExtention(assetSrc);
            if (appModels.ALLOWED_AUDIO_FILES.indexOf(fileExtention) > -1) {
                let params = [
                    {
                        key: "id",
                        target: asset.id
                    },
                    {
                        key: "type",
                        target: asset.type
                    }
                ];

                let audioIndex = getArrayObjectIndexByKeys(audioToPreload,"id",asset.id,"type",asset.type);
                //let audioIndex = getArrayObjectIndexByKey(audioToPreload, "id", assetSrc);
                if (audioIndex === -1) {
                    audioToPreload = dataHelper.immutablePush(audioToPreload, asset);
                }
            }
        }
    }
    return audioToPreload;
}

export function biteHasScreensVisibleToMenu(screens) {
    let visibleToMenuCount = 0;
    _.forEach(screens, function (screen) {
        if (screen.include_in_menu) {
            visibleToMenuCount++;
        }
    });

    return visibleToMenuCount > 0;
}

export function getPreviousObject(bite_id, screen_id, asset_id) {
    let bite = getArrayObjectByKey(localStorage.bites, "bite_id", bite_id);
    let previousObject = {};
    for (let s = 0; s < bite.screens.length; s++) {
        let screen = bite.screens[s];
        if (screen.screen_id === screen_id) {
            if (isDefined(screen.objects) && screen.objects.length > 0) {
                for (let o = 0; o < screen.objects.length; o++) {
                    let object = screen.objects[o];
                    if (object.asset_id === asset_id) {
                        if (o > 0) {
                            previousObject = Object.assign({}, screen.objects[o - 1]);
                            break;
                        }

                    }
                }
            }
        }
        if (isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
            for (let ss = 0; ss < screen.sub_screens.length; ss++) {
                let sub_screen = screen.sub_screens[ss];
                if (isDefined(sub_screen.objects) && sub_screen.objects.length > 0) {
                    for (let sso = 0; sso < sub_screen.objects.length; sso++) {
                        let object = sub_screen.objects[sso];
                        if (object.asset_id === asset_id) {
                            if (sso > 0) {
                                previousObject = Object.assign({}, sub_screen.objects[sso - 1]);
                                break;
                            }

                        }
                    }
                }
            }
        }
    }

    return previousObject;

}

export function allowScroll(bite_id, screen_id, asset_id) {

    //console.log(asset_id);
    let allowScroll = false;
    let previousObject = getPreviousObject(bite_id, screen_id, asset_id);

    if (isDefined(previousObject.asset_id)) {
        if (componentModels.ALWAY_SCROLL_AFTER.indexOf(previousObject.object_type) > -1 || componentModels.ALWAY_SCROLL_AFTER.indexOf(previousObject.asset_type_code) > -1) {
            allowScroll = true;
        } else if (componentModels.CHECK_SCROLL_AFTER.indexOf(previousObject.object_type) > -1 || componentModels.CHECK_SCROLL_AFTER.indexOf(previousObject.asset_type_code) > -1) {
            if (isDefined(previousObject.progression) && (previousObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE || previousObject.progression === objectConstants.OBJECT_PROGRESSION_GO_TO)) {
                allowScroll = true;
            }
        }

    }
   // console.log(`allowScroll: ${allowScroll}`);
    return allowScroll;
}


export function AllowAutoProgressionIfLast(asset_type_code) {
    if (componentModels.AUTO_NAVIGATE_IF_LAST_ON_INCOMPLETE_SCREEN.indexOf(asset_type_code) > -1) {
        return true;
    }
    return false;
}

export function setResourceLinks(obj) {
    let resourceLinks = [];

    if (isDefined(obj.resources) && obj.resources.length > 0) {
        _.forEach(obj.resources, function (resource) {
            resourceLinks = dataHelper.immutablePush(resourceLinks, resource);
        });
    }

    if (isDefined(obj.assets) && obj.assets.length > 0) {
        _.forEach(obj.assets, function (asset) {
            resourceLinks = dataHelper.immutablePush(resourceLinks, asset);
        });
    }

    return resourceLinks;

}


export function hasRequiredResources(resources) {
    let hasRequired = false;
    _.forEach(resources, function (resource) {
        if (resource.required) {
            hasRequired = true;
        }
    });
    return hasRequired;
}

export function getPreviousResource(resource) {
    let returnResource = {};
    if (isDefined(resource) && isDefined(resource.screen_id)) {
        let resourceIndex = getArrayObjectIndexByKey(localStorage.resources, "screen_id", resource.screen_id);
        if (resourceIndex > 0) {
            returnResource = Object.assign({}, localStorage.resources[resourceIndex - 1]);
        }
    }
    return returnResource;
}

export function getNextResource(resource) {
    let returnResource = {};
    if (isDefined(resource) && isDefined(resource.screen_id)) {
        let resourceIndex = getArrayObjectIndexByKey(localStorage.resources, "screen_id", resource.screen_id);
        if (resourceIndex > -1 && resourceIndex < (localStorage.resources.length - 1)) {
            returnResource = Object.assign({}, localStorage.resources[resourceIndex + 1]);
        }
    }
    return returnResource;
}

export function checkLinearScreenEnabled(userScreen, userBite) {

    let isEnabled = false;
    if (userScreen.status !== objectConstants.STATUS_NOT_STARTED) {
        isEnabled = true;
    } else {
        let screenIndex = getArrayObjectIndexByKey(userBite.screens, "screen_id", userScreen.screen_id);
        if (screenIndex > 0) {
            let previousUserScreen = userBite.screens[screenIndex - 1];
            if (previousUserScreen.required) {
                isEnabled = previousUserScreen.status === objectConstants.STATUS_COMPLETE;
            } else {
                let prevIndex = screenIndex - 1;
                for (let i = prevIndex; i > 0; i--) {
                    let prevScreen = userBite.screens[i];
                    if (prevScreen.required) {
                        isEnabled = prevScreen.status === objectConstants.STATUS_COMPLETE;
                        break;
                    }
                }
            }
        } else {
            isEnabled = true;
        }
    }
    return isEnabled;
}

export function checkLinearTargetScreenEnabled(userScreen, userBite, screens) {
    let isEnabled = false;
    if (userScreen.status !== objectConstants.STATUS_NOT_STARTED) {
        isEnabled = true;
    } else {
        let firstTargetScreen = getFirstTargetScreen(screens);
        if (firstTargetScreen.screen_id === userScreen.screen_id) {
            isEnabled = true;
        }
    }
    return isEnabled;
}

export function getFirstTargetScreen(screens) {
    let result = {};
    for (let i = 0; i < screens.length; i++) {
        let screen = screens[i];
        if (screen.screen_rule_type === objectConstants.SCREEN_RULE_TYPE_TARGET) {
            result = Object.assign({}, screen);
            break;
        }
    }
    return result;
}

export function getPrevTargetScreen(screenIndex, screens) {
    let result = {};
    for (let i = screenIndex; i > 0; i--) {
        let screen = screens[i];
        if (screen.screen_rule_type === objectConstants.SCREEN_RULE_TYPE_TARGET) {
            result = Object.assign({}, screen);
            break;
        }
    }
    return result;
}

export function getNextTargetScreen(screenIndex, screens) {
    let result = {};
    for (let i = screenIndex; i < screens.length; i++) {
        let screen = screens[i];
        if (screen.screen_rule_type === objectConstants.SCREEN_RULE_TYPE_TARGET) {
            result = Object.assign({}, screen);
            break;
        }
    }
    return result;
}


export function checkLinearMenuBiteEnabled(userBite, userData, learningPlanBites) {
    let isEnabled = false;
    if (userBite.status !== objectConstants.STATUS_NOT_STARTED || !userBite.required) {
        isEnabled = true;
    } else {
        let biteIndex = getArrayObjectIndexByKey(learningPlanBites, "bite_id", userBite.bite_id);
        if (biteIndex > 0) {
            let previousUserBiteId = learningPlanBites[biteIndex - 1].bite_id;
            let previousUserBite = getArrayObjectByKey(userData.bites, "bite_id", previousUserBiteId);
            if (previousUserBite.required) {
                isEnabled = previousUserBite.status === objectConstants.STATUS_COMPLETE;
            } else {
                let prevIndex = biteIndex - 1;
                for (let i = prevIndex; i > -1; i--) {
                    //let prevBite = userData.bites[i];
                    let prevBiteId = learningPlanBites[i].bite_id;
                    let prevBite = getArrayObjectByKey(userData.bites, "bite_id", prevBiteId);
                    if (isDefined(prevBite) && prevBite.required) {
                        isEnabled = prevBite.status === objectConstants.STATUS_COMPLETE;
                        break;
                    }
                }
            }
        } else {
            isEnabled = true;
        }
    }
    return isEnabled;
}

export function checkOpenMenuBiteEnabled(userBite, userData) {
    let isEnabled = false;
    if (userBite.status !== objectConstants.STATUS_NOT_STARTED) {
        isEnabled = true;
    } else {
        let biteIndex = getArrayObjectIndexByKey(userData.bites, "bite_id", userBite.bite_id);
        if (biteIndex > 0) {
            let firstBite = userData.bites[0];
            isEnabled = firstBite.status === objectConstants.STATUS_COMPLETE;
        } else {
            isEnabled = true;
        }
    }
    return isEnabled;
}

export function checkFirstLastAnyMenuBiteEnabled(userBite, userData, learningPlanBites) {
    let isEnabled = false;
    if (userBite.status !== objectConstants.STATUS_NOT_STARTED) {
        isEnabled = true;
    } else {
        let biteIndex = getArrayObjectIndexByKey(learningPlanBites, "bite_id", userBite.bite_id);
        //let biteIndex = getArrayObjectIndexByKey(userData.bites, "bite_id", userBite.bite_id);
        if (biteIndex > 0) {
            //let firstBite = userData.bites[0];
            let firstUserBiteId = learningPlanBites[0].bite_id;
            let firstBite = getArrayObjectByKey(userData.bites, "bite_id", firstUserBiteId);
            if (biteIndex < userData.bites.length - 1) {
                isEnabled = firstBite.status === objectConstants.STATUS_COMPLETE;
            } else {
                let lastIndex = userData.bites.length - 2; //minus 2 because we dont want to include the last bite
                let requiredBites = 0;
                let completeRequiredBites = 0;
                for (let i = lastIndex; i > 0; i--) {
                    //let prevBite = userData.bites[i];

                    let prevBiteId = learningPlanBites[i].bite_id;
                    let prevBite = getArrayObjectByKey(userData.bites, "bite_id", prevBiteId);

                    if (prevBite.required) {
                        requiredBites++;
                        if (prevBite.status === objectConstants.STATUS_COMPLETE) {
                            completeRequiredBites++;
                        }
                    }
                }
                isEnabled = requiredBites === completeRequiredBites;
            }
        } else {
            isEnabled = true;
        }
    }

    return isEnabled;
}

export function getAllBadges() {
    let allBadges = [];
    _.forEach(localStorage.bites, function (bite) {
        if (isDefined(bite.badges)) {
            _.forEach(bite.badges, function (badge) {
                let badgeIndex = getArrayObjectIndexByKey(allBadges, "badge_id", badge.badge_id);
                if (badgeIndex === -1) {
                    allBadges = dataHelper.immutablePush(allBadges, badge);
                }
            });
        }
    });
    return allBadges;
}

export function getScreenData(params) {
    let bite = getArrayObjectByKey(localStorage.bites, "bite_id", params.bite_id);

    return getArrayObjectByKey(bite.screens, "screen_id", params.screen_id);
}

export function getSubScreen(params) {
    let bite = getArrayObjectByKey(localStorage.bites, "bite_id", params.bite_id);
    let parentScreen = getArrayObjectByKey(bite.screens, "screen_id", params.parent_screen_id);
    return getArrayObjectByKey(parentScreen.sub_screens, "screen_id", params.screen_id);
}


export function getScreenByAssetId(asset_id) {
    let returnObject = {};
    //let screenFound = false;
    let bites = localStorage.contentData.experience.bites;
    _.forEach(bites, function (bite) {
        _.forEach(bite.screens, function (screen) {
            if (isDefined(screen.objects) && screen.objects.length > 0 && (!isDefined(screen.sub_screens) || (isDefined(screen.sub_screens) && screen.sub_screens.length === 0 ) )) {
                _.forEach(screen.objects, function (object) {
                    if (object.asset_id === asset_id) {
                        returnObject = Object.assign({}, screen);
                    }

                });
            } else if (isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
                _.forEach(screen.sub_screens, function (sub_screen) {
                    if (isDefined(sub_screen.objects)) {
                        _.forEach(sub_screen.objects, function (object) {
                            if (object.asset_id === asset_id) {
                                returnObject = Object.assign({}, sub_screen);
                            }
                        });
                    }
                });
            }
        });
    });
    return returnObject;
}

export function getScreenCharacterNameByAssetId(asset_id) {
    let characterName = "Character";
    let screen = getScreenByAssetId(asset_id);
    if (isDefined(screen)) {
        let screenLocale = getLocalData(screen);
        if (isDefined(screenLocale.character_name)) {
            characterName = screenLocale.character_name;
        }
    }
    return characterName;
}

export function getScreenNotes(parentScreen, screen, showContentOutlineInPreview, is_preview) {
    let notes = [];
    let screenLocale = getLocalData(screen);
    let showNotes = localStorage.contentData.experience.preview_display_type !== objectConstants.PREVIEW_DISPLAY_TYPE_CONTENT_ONLY;
    if (!showNotes && showContentOutlineInPreview && is_preview) {
        showNotes = true;
    }
    let showContent = true;
    if (isDefined(parentScreen)) {
        showContent =
            (
                localStorage.contentData.experience.preview_display_type !== objectConstants.PREVIEW_DISPLAY_TYPE_OUTLINE_ONLY
                ||
                (localStorage.contentData.experience.preview_display_type === objectConstants.PREVIEW_DISPLAY_TYPE_OUTLINE_ONLY && screen.show_content_when_in_outline_view)
            )
            &&
            (
                canSeeContent(parentScreen)
                ||
                (!canSeeContent(parentScreen) && screen.show_content_when_in_outline_view)
                /*||
                is_preview*/

            );
    } else {
        showContent =
            (
                localStorage.contentData.experience.preview_display_type !== objectConstants.PREVIEW_DISPLAY_TYPE_OUTLINE_ONLY
                ||
                (localStorage.contentData.experience.preview_display_type === objectConstants.PREVIEW_DISPLAY_TYPE_OUTLINE_ONLY && screen.show_content_when_in_outline_view)
            )
            &&
            (
                canSeeContent(screen)
                ||
                (!canSeeContent(screen) && screen.show_content_when_in_outline_view)
                /*||
                is_preview*/

            );
    }

    if (isDefined(parentScreen)) {
        let parentScreenLocale = getLocalData(parentScreen);
        if (isDefined(parentScreenLocale.notes) && parentScreenLocale.notes.length > 0 && parentScreenLocale.notes !== "<p><br></p>") {
            let subScreenIndex = getArrayObjectIndexByKey(parentScreen.sub_screens, "screen_id", screen.screen_id);
            if (subScreenIndex === 0) {
                let parentNotesObject = {

                    screen_id: parentScreen.screen_id,
                    notes: parentScreenLocale.notes
                };
                notes = dataHelper.immutablePush(notes, parentNotesObject);
            }
        }
    }

    if (isDefined(screenLocale.notes) && screenLocale.notes.length > 0 && screenLocale.notes !== "<p><br></p>") {
        let notesObject = {
            screen_id: screen.screen_id,
            notes: screenLocale.notes
        };
        notes = dataHelper.immutablePush(notes, notesObject);
    }

    return {
        show_notes: showNotes && notes.length > 0,
        show_content: showContent,
        notes: notes,
    };
}

export function allowClippedBlurEffect() {
    return (dataHelper.cssPropertyValueSupported('clip-path', 'inset(0px 0px 0px 40%)') || dataHelper.cssPropertyValueSupported('-webkit-clip-path', 'inset(0px 0px 0px 40%)')) && dataHelper.cssPropertyValueSupported('filter', 'blur(3px)');
}

export function getAllPrintableAssets() {
    let printableAssets = [];
    _.forEach(localStorage.bites, function (bite) {
        _.forEach(bite.screens, function (screen) {
            if (isDefined(screen.objects) && screen.objects.length > 0 && (!isDefined(screen.sub_screens) || (isDefined(screen.sub_screens) && screen.sub_screens.length === 0 ) )) {
                _.forEach(screen.objects, function (object) {
                    if (isDefined(object.print_type) && object.print_type === objectConstants.INCLUDE_IN_PRINT) {
                        object = Object.assign({}, object, {
                            bite_id: bite.bite_id,
                            screen_id: screen.screen_id
                        });
                        printableAssets = dataHelper.immutablePush(printableAssets, object);
                    }

                });
            } else if (isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
                _.forEach(screen.sub_screens, function (sub_screen) {
                    if (isDefined(sub_screen.objects)) {
                        _.forEach(sub_screen.objects, function (object) {
                            if (isDefined(object.print_type) && object.print_type === objectConstants.INCLUDE_IN_PRINT) {
                                object = Object.assign({}, object, {
                                    bite_id: bite.bite_id,
                                    screen_id: sub_screen.screen_id
                                });
                                printableAssets = dataHelper.immutablePush(printableAssets, object);
                            }
                        });
                    }
                });
            }
        });
    });
    return printableAssets;
}

export function getPrintableAssetsByBite(bite_id) {
    let printableAssets = [];
    let bite = getArrayObjectByKey(localStorage.bites, "bite_id", bite_id);
    _.forEach(bite.screens, function (screen) {
        if (isDefined(screen.objects) && screen.objects.length > 0 && (!isDefined(screen.sub_screens) || (isDefined(screen.sub_screens) && screen.sub_screens.length === 0 ) )) {
            _.forEach(screen.objects, function (object) {
                if (isDefined(object.print_type) && object.print_type === objectConstants.INCLUDE_IN_PRINT) {
                    object = Object.assign({}, object, {
                        bite_id: bite.bite_id,
                        screen_id: screen.screen_id
                    });
                    printableAssets = dataHelper.immutablePush(printableAssets, object);
                }

            });
        } else if (isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
            _.forEach(screen.sub_screens, function (sub_screen) {
                if (isDefined(sub_screen.objects)) {
                    _.forEach(sub_screen.objects, function (object) {
                        if (isDefined(object.print_type) && object.print_type === objectConstants.INCLUDE_IN_PRINT) {
                            object = Object.assign({}, object, {
                                bite_id: bite.bite_id,
                                screen_id: sub_screen.screen_id
                            });
                            printableAssets = dataHelper.immutablePush(printableAssets, object);
                        }
                    });
                }
            });
        }
    });

    return printableAssets;
}

export function screenExists(screen_id) {
    let screen_exists = false;
    _.forEach(localStorage.bites, function (bite) {
        _.forEach(bite.screens, function (screen) {
            if (screen.screen_id === screen_id) {
                screen_exists = true;
            }
        });
    });
    return screen_exists;
}

export function getOptionResultString(result, isMissed) {
    let optionString = isMissed ? `${getLocaleString("this_is_a_missed")} ` : `${getLocaleString("this_is_a")} `;
    switch (result) {

        case objectConstants.RESULT_BEST:
            optionString += `${getLocaleString("best_label")} `;
            break;
        case objectConstants.RESULT_OK:
            optionString += `${getLocaleString("ok_label")} `;
            break;
        case objectConstants.RESULT_POOR:
            optionString += `${getLocaleString("poor_label")} `;
            break;
        case objectConstants.RESULT_REFLECTIVE:
            optionString += `${getLocaleString("reflective_label")} `;
            break;
    }

    optionString += `${getLocaleString("option_label")}. `;
    return optionString;
}

export function isSingleScreenModule() {
    if (localStorage.bites.length < 2) {
        return localStorage.bites[0].screens.length < 2;
    } else {
        return false;
    }
}


/** WEBPACK FOOTER **
 ** ./src/helpers/appHelper.js
 **/